module.exports = __webpack_public_path__ + "img/checkout-file.789048be.svg";